<template>
	<v-app>
		<v-row class="px-4">
      <LoadingDialog v-if="loading" :is_loading=loading></LoadingDialog>

      <!-- Graphs -->
      <v-col cols="12">
        <v-card
          v-if="!loading"
          elevation="0"
          style="margin-top: 15px;">
          <v-card-title>
            <v-row>
              <v-col>
                {{ $t('_cascade_des_pertes_') }}
              </v-col>
<!--              <v-col class="col-sm-4" v-if="has_pdm">-->
<!--                <tree-select-->
<!--                  v-if="has_pdm"-->
<!--                  v-model="ts_values"-->
<!--                  :auto-load-root-options=false-->
<!--                  :defaultExpandLevel="expand_level"-->
<!--                  :disable-branch-nodes=true-->
<!--                  :load-options="getAllPdmTree"-->
<!--                  :multiple=false-->
<!--                  :options="ts_options"-->
<!--                  :showCount=true-->
<!--                  placeholder="$t('_selectionner_un_point_de_mesure_')"-->
<!--                  v-on:input="changePdm(ts_values)"-->
<!--                >-->
<!--                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>-->
<!--                </tree-select>-->
<!--              </v-col>-->
            </v-row>

          </v-card-title>
        </v-card>
        <v-card
          v-if="!loading"
          elevation="0"
        >
          <v-card-text>
            <plotly-graph
              :dates="dates"
              :graph_data="graph_data_1"
              style="padding: 20px;"
            />
            <plotly-graph
              v-if="showGraph2"
              :dates="dates"
              :graph_data="graph_data_2"
              style="padding: 20px;"
            />
          </v-card-text>
        </v-card>
      </v-col>
		</v-row>
	</v-app>
</template>

<script>


import api from "@/api/api";
import cd from '@/utils/compute_data.js';
import LoadingDialog from "@/components/Utils/LoadingDialog";
import PlotlyGraph from "../../components/Plotly/PlotlyGraph";
// import TreeSelect from '@riophae/vue-treeselect'
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
	components: {
		LoadingDialog,
    PlotlyGraph,
    // TreeSelect,
	},

	data() {
		return {
      loading: false,

			// Params
			installation_id: this.$route.params.id,
      expand_level: 0,

      // Graphics
      current_pdm: null,
      has_pdm: true,

      graph_data_1: {},
      graph_data_2: {},

      hasOneGraph: false,
      showGraph2: false,

      startMonth: null,

      ts_values: null,
      ts_options: [],
		};
	},

	computed: {
		installation() {
			return this.$store.getters.installations.find(
				(x) => x.id == this.installation_id
			)
		},

    dates() {
			return this.$store.state.parametersStore.dates
		},

		auditDates() {
			return this.$store.state.parametersStore.audit_dates
		},

	},

	watch: {
		route: {
			async handler() {
        await this.getAllPdmTree()
        await this.renderGraphModel()
        await this.refreshPdm()
      },
			immediate: true,
		},

    '$store.getters.dates': {
      async handler() {
        this.$store.commit('SET_MAIN_CALENDAR_REFRESH', false)
        await this.renderGraphModel()
        await this.refreshPdm()
      },
      deep: true
     },

    async '$root.$i18n.locale'() {
      await this.getAllPdmTree()
      await this.renderGraphModel()
      await this.refreshPdm()
    },

	},

	methods: {
    async changePdm(pdm) {
      if (pdm !== undefined && pdm !== null) {
        this.current_pdm = pdm
        await this.refreshPdm()
      } else {
        this.current_pdm = null
      }

    },

    getMenu() {
      return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.target_menu
    },

    async getAllPdmTree() {
      const langcode = this.$root.$i18n.locale

      await api
        .getPdmTree(this.installation_id, langcode)
        .then((res) => {
          res.data['tree'].map((elm) => this.ts_options.push(elm));
          this.expand_level = res.data['expand_level']
        });
    },

    async renderGraphModel() {
      this.loading = true

      let graphs = null
      this.showGraph2 = false

      await api
        .getReportFullName(this.$route.name, this.getMenu())
        .then((res_mod) => {
          this.hasOneGraph = res_mod.data.length === 1
          graphs = res_mod.data
        })

      this.query_param = {}
      this.query_param['installation_id'] = this.installation.id
      this.query_param['start_date'] = this.$store.getters.dates.start
      this.query_param['end_date'] = this.$store.getters.dates.end
      this.query_param['date_interval'] = null
      this.query_param['export_type'] = null
      this.query_param['pacgrid'] = this.installation.elec_var.includes("Pac@grid")
      if (graphs !== undefined) {
        // Graph 1
        this.query_param['sel_pdm'] = null

        await api
            .getTemplateRenderByName(graphs[0][1], this.$root.$i18n.locale, this.query_param)
            .then((res) => {
              this.graph_data_1  = {
                "data_render": res.data.data,
                "layout_render": res.data.layout
              }
            })
      }

      this.loading = false
    },

    async refreshPdm() {
      let graphs = null
      this.showGraph2 = false

      if (this.current_pdm == null) return

      this.loading = true

      await api
        .getReportFullName(this.$route.name, this.getMenu())
        .then((res_mod) => {
          graphs = res_mod.data
        })

      this.query_param = {}
      this.query_param['installation_id'] = this.installation.id
      this.query_param['start_date'] = this.$store.getters.dates.start
      this.query_param['end_date'] = this.$store.getters.dates.end
      this.query_param['date_interval'] = null
      this.query_param['export_type'] = null
      this.query_param['pacgrid'] = this.installation.elec_var.includes("Pac@grid")
      if (graphs !== undefined) {
        // Graph 2
        if (this.current_pdm !== null && graphs.length >= 2) {
          this.query_param['sel_pdm'] = cd.parsePdmId(this.current_pdm)

          await api
              .getTemplateRenderByName(graphs[1][2], this.$root.i18.locale, this.query_param)
              .then((res) => {
                this.graph_data_2 = {
                  "data_render": res.data.data,
                  "layout_render": res.data.layout
                }
                this.showGraph2 = true
              })
        }
      }

      this.loading = false
    },

	},
};
</script>

<style scoped>
	.v-select-like {
		border: 1px solid black !important; 
		width:100%;
		display: block;
		border-radius: 4px;
		outline: none;
		color: black;
	}

  .vue-treeselect {
    font-size: 0.9rem;
    font-weight: normal;
  }

  .v-card__subtitle, .v-card__text, .v-card__title {
    /*padding: 16px 16px 0px 16px;*/
    border-bottom: #eee solid 1px;
  }

  html {
    overflow: hidden !important;
  }

</style>
